function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 873.12 733.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M270.59,20.1h328.66c80.96-.82,156.91,39.08,202.18,106.21,57.22,87.94,92.76,230.28-37.04,425.53-44.51,67.84-111.68,117.65-189.53,140.54-83.36,25.41-172.01,27.94-256.69,7.33-77.51-21.34-145.03-69.28-190.73-135.42C49.75,454.37-54.25,249.28,98.63,90.17,144.09,44.48,206.15,19.19,270.59,20.1Z",
    style: {
      fill: "none",
      stroke: "#09d084",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "40.15px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.53,
    cy: 353.18,
    r: 69.17,
    style: {
      fill: "#09d084",
      stroke: "#09d084",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.83,
    cy: 508.68,
    r: 69.17,
    style: {
      fill: "#09d084",
      stroke: "#09d084",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.74,
    cy: 508.68,
    r: 69.17,
    style: {
      fill: "#09d084",
      stroke: "#09d084",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.83,
    cy: 197.58,
    r: 41.46,
    style: {
      fill: "#09d084",
      stroke: "#09d084",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.74,
    cy: 197.58,
    r: 41.46,
    style: {
      fill: "#09d084",
      stroke: "#09d084",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.85,
    cy: 353.18,
    r: 69.17,
    style: {
      fill: "#09d084",
      stroke: "#09d084",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.21,
    cy: 353.18,
    r: 69.17,
    style: {
      fill: "#09d084",
      stroke: "#09d084",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2);
export default __webpack_public_path__ + "static/media/type2.b698124669b319dcb353a87b72a856c7.svg";
export { ForwardRef as ReactComponent };